const striptags = require('striptags')
const Entities = require('html-entities').AllHtmlEntities
const entities = new Entities()

const htmlStripper = s => {
  return entities.decode(striptags(s)).trim()
}

export default htmlStripper
